// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3MqLU","large":"styles_large__1zJ78"};